import { useMediaQuery } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import AssignmentInd from '@material-ui/icons/AssignmentInd';
import React, { useEffect, useState } from 'react';
import {
    ArrayInput, Button, Create, Loading, NumberInput, required, SaveButton, SimpleForm, TextInput, Toolbar, useNotify
} from 'react-admin';
import { FormSpy } from 'react-final-form';
import SimpleFormIterator from '../formIterator/SimpleFormIterator';
import { differentDeZero, get_total_general, infOuEgalA100, json, valideTotal } from '../references.js';
import Customer from './Customer';
import OrderFooter from './OrderFooter';
const marginRight ={marginRight:10};

const useStyles = makeStyles({
    toolbar: {
        display: 'flex',
        justifyContent: 'space-between',
    },
});

const  CreateOrder =(props,...rest) => {

    const [listFretDisponible, setListFretDisponible] = useState([]);
    const [disabledSaveButton, setDisabledSaveButton] = useState(true);
    const [total, setTotal] = useState(0);
    const [isAlreadyClient, setIsAlreadyClient] = useState(false);
    const [clone, setClone] = useState(null);
    const notify = useNotify();
    const isSmall = useMediaQuery(theme => theme.breakpoints.down('sm'));
    const {resource,permissions}=props;


   useEffect(() => {
        if(!localStorage.getItem('fromShow')) {
            localStorage.removeItem('clone');
        }
        localStorage.removeItem('fromShow');

        fetch(process.env.REACT_APP_URL+"/camp/getCampagneByTypeAndStatus?status=ATTENTE&resource="+resource, 
            {   method: 'GET',
                headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json;charset=UTF-8',
                        "Authorization": "Bearer "+ localStorage.getItem('token')
                }
            }
        ).then(json)
        .then((data) => {
            if(data && data.status>310 && data.error){
                notify(data.error+' : '+data.message,'error');
            } else if(data.totalElements===0) {
                notify("Aucune campagne aérien n'est disponible !","warning");
            }else{
                setListFretDisponible(data.content);
            }
        }).catch((e) => {
            notify("Erreur lors du processus de récupération des campagnes !", 'warning')
        });

        setClone(JSON.parse(localStorage.getItem('clone')));
   
    }, []);


    const change = (formValues)=>{
        const total_general=get_total_general(formValues);
        setTotal(total_general);
        if(total_general!==0 && !formValues.gratuit_excep) setDisabledSaveButton(false);
        
    }
    
    const deja_client=()=>{
        alert("Déjà client");
    }

    const CustomToolbar = (props) => (
        <Toolbar {...props}  classes={useStyles()}>
            <SaveButton disabled={disabledSaveButton}/>
            <Button label="Déjà client ?" onClick={()=>deja_client()}><AssignmentInd/></Button>
        </Toolbar>
    );

  return (
   
    listFretDisponible.length >0 ?

      <Create {...props} title={"Total : "+total  +" €"}  >
        <SimpleForm  {...props}  submitOnEnter={true}  redirect="show" margin="none"   toolbar={<CustomToolbar />} initialValues={clone? clone:null} >    
        <Customer listFretDisponible={listFretDisponible} permissions={permissions}/> 
           <ArrayInput validate={required()} expanded={true} source="lines_colis" fullWidth label="Ajouter les colis"  >
                <SimpleFormIterator >                
                    <TextInput source="description"  label="Description"   style ={marginRight} validate={required()}   />  
                    <NumberInput  source="quantite"   label="Quantité"   validate={[required(),differentDeZero,infOuEgalA100]} style={marginRight} />
                    <NumberInput  source="poids" label="Poids(kg)" style ={marginRight} validate={[required(),differentDeZero]} />   
                    <NumberInput  source="prix_unitaire" label="Prix unitaire"   validate={[required(),differentDeZero]} style ={marginRight} />
                    <NumberInput  min="0" source={"total_line"} label="Total" style ={marginRight} validate={[valideTotal]} />
                </SimpleFormIterator>
            </ArrayInput>
            <OrderFooter />   
            <TextInput {...rest} style={isSmall ? {width:'100%'}:{width:'20%',marginRight:20}} fullWidth source="ancien_code"  label="Ancien code"   />
            <FormSpy
                onChange={props => {
                    change(props.values);
                }}
            />
        </SimpleForm>
    </Create> :<Loading />
    );
};

export default CreateOrder;
